import React, { useState, useEffect } from 'react';

const PosterSettings = ({ userdata }) => {
    const [formData, setFormData] = useState({
        logo: '',
        fullName: '',
        phoneNumber: '',
        email: '',
        address: '',
        website: '',
        specialization: ''
    });

    const [logoPreview, setLogoPreview] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setLogoPreview(reader.result);
                setFormData(prev => ({
                    ...prev,
                    logo: reader.result
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission here
        console.log('Poster settings submitted:', formData);
        // You can add API call here to save the poster settings
    };

    const handleReset = () => {
        setFormData({
            logo: '',
            fullName: '',
            phoneNumber: '',
            email: '',
            address: '',
            website: '',
            specialization: ''
        });
        setLogoPreview(null);
    };

    return (
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="dc-securityhold tab-pane active fade show" id="dc-security">
                <div className="dc-securitysettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle" style={{ display: 'flex', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                            <h3 style={{ margin: 0 }}>Poster Settings</h3>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="dc-formtheme dc-formprojectinfo">
                        <div className="row">
                            {/* Logo Upload Section */}
                            <div className="col-12">
                                <div className="dc-formgroup">
                                    <div className="dc-label">
                                        <span>Logo/Profile Picture</span>
                                    </div>
                                    <div className="dc-fileupload">
                                        <input 
                                            type="file" 
                                            id="logo-upload" 
                                            accept="image/*" 
                                            className="form-control"
                                            onChange={handleLogoUpload}
                                            style={{ display: 'none' }}
                                        />
                                        <label htmlFor="logo-upload" className="dc-fileupload-label">
                                            <i className="fa fa-upload"></i>
                                            <span>Upload Logo</span>
                                        </label>
                                        {logoPreview && (
                                            <div className="dc-logo-preview" style={{ marginTop: '10px' }}>
                                                <img 
                                                    src={logoPreview} 
                                                    alt="Logo Preview" 
                                                    style={{ 
                                                        width: '100px', 
                                                        height: '100px', 
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        border: '2px solid #ddd'
                                                    }} 
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Basic Information */}
                            <div className="col-lg-6 col-md-12">
                                <div className="dc-formgroup">
                                    <div className="dc-label">
                                        <span>Full Name *</span>
                                    </div>
                                    <input 
                                        type="text" 
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                        className="dc-form-control" 
                                        placeholder="Enter your full name"
                                        required 
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12">
                                <div className="dc-formgroup">
                                    <div className="dc-label">
                                        <span>Phone Number *</span>
                                    </div>
                                    <input 
                                        type="tel" 
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                        className="dc-form-control" 
                                        placeholder="Enter phone number"
                                        required 
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12">
                                <div className="dc-formgroup">
                                    <div className="dc-label">
                                        <span>Email Address</span>
                                    </div>
                                    <input 
                                        type="email" 
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        className="dc-form-control" 
                                        placeholder="Enter email address"
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12">
                                <div className="dc-formgroup">
                                    <div className="dc-label">
                                        <span>Website</span>
                                    </div>
                                    <input 
                                        type="url" 
                                        name="website"
                                        value={formData.website}
                                        onChange={handleInputChange}
                                        className="dc-form-control" 
                                        placeholder="Enter website URL"
                                    />
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="dc-formgroup">
                                    <div className="dc-label">
                                        <span>Address *</span>
                                    </div>
                                    <textarea 
                                        name="address"
                                        value={formData.address}
                                        onChange={handleInputChange}
                                        className="dc-form-control" 
                                        rows="3"
                                        placeholder="Enter complete address"
                                        required
                                    ></textarea>
                                </div>
                            </div>

                            {/* Professional Information */}
                            <div className="col-lg-6 col-md-12">
                                <div className="dc-formgroup">
                                    <div className="dc-label">
                                        <span>Specialization *</span>
                                    </div>
                                    <input 
                                        type="text" 
                                        name="specialization"
                                        value={formData.specialization}
                                        onChange={handleInputChange}
                                        className="dc-form-control" 
                                        placeholder="e.g., Cardiology, Dermatology, etc."
                                        required 
                                    />
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PosterSettings;
